import React from "react";

const ListLoader = () => {
  return (
    <div className="px-6 md:px-10 lg:px-16 pb-10 bg-white">
      {/* Static heading */}
      <div className="py-10">
        <h1 className="text-4xl font-segoe font-bold">Research papers</h1>
      </div>

      {/* Animated list rows */}
      <div className="w-full animate-pulse">
        {[...Array(5)].map((_, index) => (
          <div key={index}>
            <div className="bg-white w-full border-solid flex py-5">
              <div className="w-[50%] h-5 bg-gray-200 rounded mr-4"></div>
              <div className="w-[25%] h-5 bg-gray-200 rounded mx-auto"></div>
              <div className="w-[25%] h-5 bg-gray-200 rounded mx-auto"></div>
            </div>
            <div className="w-[200%] ml-[-50%] h-[1px] bg-gray-200"></div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ListLoader;
